import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: "replaceBreakes"
})
export class ReplaceBreakes implements PipeTransform{

    transform(content){
        if (!content) return content;

        let res = content.replace("\n", "<br />");
        return res;
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/replace.breakes.ts